export enum ClientType {
  Web = "web",
  Browser = "browser",
  Desktop = "desktop",
  // Mobile = "mobile",
  Cli = "cli",
  // DirectoryConnector = "connector",
}
